module.exports = __webpack_public_path__ + "static/media/contrast.ed34ec1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/contrast.svg
// module id = 2677
// module chunks = 7